<template>
  <div
    v-block-loading:init="loading"
    class="m-live-player"
    :retry-message="errorText"
    :class="{
      app: isAppWebview
    }"
  >
    <div
      v-show="loading === false"
      id="playercontainer"
    >
      <!-- iframe player 直播 -->
      <div
        v-if="iframePlayer"
        class="iframe-player-container"
      >
        <!-- app webview 无法全屏 -->
        <iframe
          v-if="isAppWebview || !allowfullscreen"
          id="iframePlayer"
          class="iframe-player"
          frameborder="0"
          :src="source"
          width="100%"
          fs="0"
        />

        <!-- web 用 -->
        <iframe
          v-else
          id="iframePlayer"
          class="iframe-player"
          frameborder="0"
          :src="source"
          width="100%"
          allowfullscreen
        />
      </div>

      <!-- live stream 直播 -->
      <template v-else>
        <video :src="source">
          <source
            :src="source"
            type="video/webm"
          >
          <source
            :src="source"
            type="video/mp4"
          >
          <source
            :src="source"
            type="application/x-mpegURL"
          >
        </video>
      </template>
    </div>

    <template v-if="channelList.length">
      <!-- 对阵信息 -->
      <MatchInfo
        v-if="event"
        :event="event"
      />

      <!-- 切换直播线路 -->
      <SwitchChannel
        :channel-list="channelList"
        :current-source="source"
        @change="onChangeChannel"
      />
    </template>
  </div>
</template>

<script>
import axios from 'axios'
import { storeToRefs } from 'pinia'
import { useAppStore } from '@ms/stores/app'
import { fetchMatchLiveStream } from '@ms/api/match'
import MatchInfo from './pagelet/MatchInfo'
import SwitchChannel from './pagelet/SwitchChannel'

export default {
  name: 'LivePlayer',
  components: {
    MatchInfo,
    SwitchChannel
  },
  props: {
    eventId: {
      type: String,
      default: ''
    },
    allowfullscreen: {
      type: Boolean,
      default: true
    },
    event: {
      type: Object,
      default: null
    }
  },
  setup() {
    const { isAppWebview } = storeToRefs(useAppStore())

    return {
      isAppWebview
    }
  },
  data() {
    return {
      loading: false,
      errorText: '',
      // 视频地址
      source: '',
      // 视频线路列表
      channelList: [],
      iframePlayer: false
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    mountSdk() {
      return new Promise((resolve) => {
        if (window.avvpl) {
          return resolve()
        }
        const script = document.createElement('script')
        const link = document.createElement('link')
        script.src = 'https://avplayer-cdn.sportradar.com/dist/latest/avvpl-player.js'
        link.rel = 'stylesheet'
        link.href = 'https://avplayer-cdn.sportradar.com/dist/latest/styles.css'

        document.querySelector('body').appendChild(script)
        document.querySelector('head').appendChild(link)
        script.addEventListener('load', resolve)
      })
    },
    onChangeChannel(source) {
      this.source = source
    },
    parseChannel(data = '') {
      if (data.indexOf('|') !== -1) {
        this.channelList = data.split('|')
        this.source = this.channelList[0]
      } else {
        this.source = data
      }
    },
    async mountSteamPlayer() {
      await this.mountSdk()
      this.loading = false
      new window.avvpl.setupPlayer({
        id: 'playercontainer',
        autoplay: true,
        handlers: ['html5', 'hls'],
        allowFullScreen: !(this.isAppWebview || !this.allowfullscreen)
      })
    },
    async setupIframePlayer() {
      this.iframePlayer = true
      return new Promise((resolve) => {
        this.$nextTick(() => {
          document.getElementById('iframePlayer').onload = () => {
            return resolve()
          }
        })
      })
    },
    async init() {
      this.loading = true
      const { error, data: source } = await fetchMatchLiveStream(this.eventId)
      if (error) {
        this.errorText = error.message
        this.loading = -1
        return
      }

      // 通过域名区分类型, 示例见 ./README.md
      if (/sociablekit\.com/.test(source)) {
        // 多路线类型
        // const source = 'https://www.sociablekit.com/app/embed/youtube-channel-videos/widget_feed_json.php?embed_id=53949&device=mobile'
        await axios.get(source).then(({ data }) => {
          console.log(data)
          const channelList = data.posts.map((x) => {
            return {
              source: `https://www.youtube.com/embed/${x.id}?showinfo=1&autoplay=0`,
              title: x.title.match(/[a-z]+[\w\s]+/i)[0]
            }
          })
          // https://www.youtube.com/embed/sxYVKSW8XZM?showinfo=1&autoplay=0
          this.channelList = channelList
          this.source = channelList[0].source
        })
        await this.setupIframePlayer()
      } else {
        this.parseChannel(source)
        if (/\.(twitch|youtube)\./.test(source)) {
          await this.setupIframePlayer()
        } else {
          await this.mountSteamPlayer()
        }
      }

      this.errorText = ''
      this.loading = false
    }
  }
}
</script>

<style lang="less">
.m-live-player {
  position: relative;

  &.app {
    // app 隐藏全屏按钮
    .sravvpl_fullscreen-normal {
      display: none !important;
    }
  }

  // 宽高比 4:3
  .iframe-player-container {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 75%;

    .iframe-player {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
